import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BillingScheduleService } from './billing-schedule.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IBillingScheduleDetail, IScheduleAndEvent } from 'app/core/interfaces/billing.interface';
import { IRiderPayorBillingDefault } from 'app/core/interfaces/rider-payor.interface';
import { Subscription } from 'rxjs/Subscription';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-billing-scheduled-edit',
  templateUrl: './billing-scheduled-edit.component.html',
  styleUrls: ['./billing-scheduled-edit.component.scss']
})
export class BillingScheduledEditComponent implements OnInit, OnDestroy {

  formSchedule: FormGroup;
  billingScheduleList: IScheduleAndEvent[] = [];
  eventSchedule: IBillingScheduleDetail[] = [];
  reasonForTransport = [];
  subscriptions: Subscription[] = [];
  tirpsId = [];
  payors: IRiderPayorBillingDefault[] = [];
  billingStatus = [];

  constructor(
    private fb: FormBuilder,
    private billingScheduleService: BillingScheduleService,
    private sweetAlertHelper: SweetAlertHelper,
    private t2LoadingService: T2LoadingService,
  ) {
    this.intiForm();
  }

  ngOnInit() {
    this.callOnInit();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  loadBillingSatus() {
    this.billingStatus = Object.keys(constant.BILLING_STATUS_LIST).map((item, index) => {
      return { description: item, id: index + 1 };
    });
  }

  callOnInit() {
    this.loadBillingSatus();
    this.callServices();
    this.changeForm();
    this.observables();
  }

  intiForm() {
    this.formSchedule = this.fb.group({
      billingstatusid: [null],
      tripids: [null, Validators.required],
      note: [null, Validators.required],
      billingscheduledetailid: [null],
      billingscheduleid: [null],
    });
  }

  callServices() {
    this.billingScheduleService.getBillingSchedule().subscribe((res) => {
      if (res && res.length) {
        this.billingScheduleList = res;
      }
    }, (error) => this.sweetAlertHelper.captureException(error));

  }

  changeForm() {
    this.formSchedule.get('billingscheduleid').valueChanges.subscribe((id: number) => {
      this.formSchedule.get('billingscheduledetailid').setValue(null);
      this.eventSchedule = [];
      if (id) {
        this.getDetailsEvent(id);
      }
    });
  }

  observables() {
    this.subscriptions.push(
      this.billingScheduleService.formData$.subscribe((data) => {
        if (data && Object.keys(data).length) {
          this.getTripId(data);
        }
      })
    );
  }

  getTripId(data) {
    if (data && data.length) {
      this.formSchedule.patchValue({
        tripids: data.map((item) => item.tripid)
      });
    }
  }

  getDetailsEvent(id: number) {
    const data = this.billingScheduleList.find(item => item.billingscheduleid === id);
    if (data && data.billingscheduledetails.length) {
      this.eventSchedule = data.billingscheduledetails;
    }
  }

  onSave() {
    const formData = Object.assign({}, this.formSchedule.value);
    this.confirmationDetails(formData)
      .then((result) => {
        if (result.value) {
          this.t2LoadingService.show();
          this.billingScheduleService.postDataSchedule(formData).subscribe((resp) => {
            if (resp) {
              this.showErrorService(resp);
              this.t2LoadingService.hiden();
            }
          }, (error) => this.sweetAlertHelper.captureException(error)
            .then(() => this.t2LoadingService.hiden()));
        }
      });

  }

  confirmationDetails(formData) {
    const nameSchedule = this.billingScheduleList.find((item) => item.billingscheduleid === formData.billingscheduleid);
    const satusName = this.billingStatus.find((item) => item.id === formData.billingstatusid);
    const event = this.eventSchedule.find((item) => item.billingscheduledetailid === formData.billingscheduledetailid);
    return this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure you want to modify trips?',
      html: `<div class="container margin-t-5 height-180 scrollbar scrollbar-small">
                <h4>Selected Trips: </h4> ${formData.tripids.length}
                ${satusName ? ` <h4>Status: </h4>` : ''}
                  <div class="container scrollbar scrollbar-small">${satusName ? satusName.description : ''}</div>
                ${nameSchedule ? `<h4>Schedule Name: </h4>` : ''}
                  <div class="container scrollbar scrollbar-small">${nameSchedule ? nameSchedule.schedulename : ''}</div>
                ${event ? `<h4>Event: </h4>` : ''}
                  <div class="container scrollbar scrollbar-small">${event ? event.eventdescription : ''}</div>
              <div class="container height="auto" scrollbar scrollbar-small">
              </div>
            </div>
            `,
      type: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonColor: '#d33',
    });
  }

  onCloseEdit() {
    this.billingScheduleService.modalClosed.emit(true);
  }

  showErrorService(trips: any) {
    const tripsErrors = [];
    const tripsSuccessful = [];
    trips.forEach(element => {
      if (element.filedarray.length) {
        tripsErrors.push(element);
      } else {
        tripsSuccessful.push(element);
      }
    });
    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
        `<div>
        <p><strong>
          Reservation: ${element.consecutive}
        </p></strong>`;
      element.filedarray.forEach(elem => {
        messages += `
          <p>
            ${elem.description}
          </p>
        `;
      });
      messages += `</div>`;
    });

    this.sweetAlertHelper.createCustomAlert({
      title: '<strong>Trips Errors</strong>',
      html: `
          <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
          <div class="color-danger">
            Error Trips: <strong>${tripsErrors.length}</strong>
          <div>
          <div class="margin-t-10"><strong>Details of Fails</strong><div>
          <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
            ${messages}
          </div>
        `,
      type: 'info',
      showCancelButton: false,
      confirmButtonText: 'Accept',
      cancelButtonText: 'Cancel'
    }).then(() => {
      this.billingScheduleService.modalClosed.emit(true);
      this.billingScheduleService.eventSave.emit(true);
    });
  }

  get showReason(): boolean {
    return !!this.reasonForTransport.length;
  }

  get disabledBtnSave(): boolean {
    const { billingstatusid, billingscheduledetailid } = this.formSchedule.getRawValue();
    return (billingstatusid || billingscheduledetailid) && this.formSchedule.valid;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/billing-scheduled-edit/billing-scheduled-edit.component.ts